import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import { filterAndDestroy } from '../../utility/objectUtility'
import { camelToSnake } from '../../utility/stringUtility'
import Form from 'vform'
import store from '../../store'

function returnFactory(model, form) {
    const create = function (form, obj) {
        linq.from(obj)
            .select((x) => {
                form[x.key] = x.value
            })
            .toArray()
        return form
    }
    return { model: model, form: create(form, model.getPostable()) }
}

export const state = {
    dragData: null,
    dragDataSrc: null,
    dragLeftForm: new Form(),
    dragRightForm: new Form(),
}

export const mutations = {
    [action.SET_DRAG_DATA](state, model) {
        state.dragData = model
    },

    [action.SET_DRAG_DATA_SRC](state, list) {
        state.dragDataSrc = list
    },

    [action.CLEAR_DRAG_FORM](state) {
        state.dragLeftForm = new Form()
        state.dragRightForm = new Form()
    },
}

export const actions = {
    async [action.ADD_LEFT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `ADD${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, model))
    },

    async [action.DELETE_LEFT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `DELETE${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, state.dragLeftForm))
    },

    async [action.UPDATE_LEFT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `UPDATE${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, state.dragLeftForm))
    },

    async [action.DETACH_LEFT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `DETACH${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, state.dragRightForm))
    },

    async [action.FETCH_LEFT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `FETCH${name.toUpperCase()}S`
        await store.dispatch(action, returnFactory(model, state.dragRightForm))
    },

    async [action.ADD_RIGHT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `ADD${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, model))
    },

    async [action.UPDATE_RIGHT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `UPDATE${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, state.dragRightForm))
    },

    async [action.DELETE_RIGHT_DRAG]({ commit, state }, model) {
        const name = camelToSnake(model._model)
        const action = `DELETE${name.toUpperCase()}`
        await store.dispatch(action, returnFactory(model, state.dragRightForm))
    },

    [action.SET_DRAG_DATA]({ commit }, model) {
        commit(action.SET_DRAG_DATA, model)
    },

    [action.SET_DRAG_DATA_SRC]({ commit }, list) {
        commit(action.SET_DRAG_DATA_SRC, list)
    },

    [action.CLEAR_DRAG_FORM]({ commit }) {
        commit(action.CLEAR_DRAG_FORM)
    },
}

export const getters = {
    [getter.DRAG_DATA]: (state) => state.dragData,
    [getter.DRAG_DATA_SRC]: (state) => state.dragDataSrc,
    [getter.DRAG_LEFT_FORM]: (state) => state.dragLeftForm,
    [getter.DRAG_RIGHT_FORM]: (state) => state.dragRightForm,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/drags.js